module.exports = __webpack_public_path__ + "voicecall_70x70.b651a1f230ee1aea148c87773d533faf.png";